'use client'

import { Filters } from './Filters'
import { FlightDetailsCardHeader } from './FareFamilyCardHeader'
import { FlightCard, FlightRouteInfo, JsonsData } from '@/src/types/flight'
import { Box } from '@mui/material'

export type FareSelectionHeaderProps = {
    handleClose: () => void
    selectedFilters: string[]
    onFilterChange: (label: string, checked: boolean) => void
    selectedFlightIndex: number
    setSelectedFlightIndex: (index: number) => void
    fareFamilySectors?: FlightRouteInfo[]
    jsons? : JsonsData
    flight: FlightCard
}


export default function FareFamilyHeader(props: FareSelectionHeaderProps) {

    return (
        <Box>
            {props.fareFamilySectors && <FlightDetailsCardHeader sectorData={props.fareFamilySectors} jsons={props.jsons} flight={props.flight} />}
            <Filters selectedFilters={props.selectedFilters} onFilterChange={props.onFilterChange} />
        </Box>
    )
}